import React from 'react';
import classNames from 'classnames';

import FacetItem from '../facet-item/FacetItem';

import styles from './SingleItemFacet.module.scss';

const SingleItemFacet = ({ facet, mobile, href = '/' }) => {
  const { values, show } = facet || {};

  if (!show || !values || values.length === 0) {
    return null;
  }

  return (
    <ul
      className={classNames(styles.content, { [styles.contentMobile]: mobile })}
    >
      {values.map((value) => {
        const { facetId } = value;

        return (
          <FacetItem
            key={facetId}
            href={href}
            mobile={mobile}
            value={value}
            dimensionName="singleItem"
          />
        );
      })}
    </ul>
  );
};

export default SingleItemFacet;
